import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const ReveniRate = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  flex-shrink: 0;
`

export const ReveniLogo = styled.img`
  height: ${props => props.theme.size.XXS};
`
